import { Dayjs } from "dayjs"
import { IReferral } from "./referral.types"

export class Referral implements IReferral {
  constructor(
    public code: string,
    public referredDate: Dayjs,
    public referrerUserId: string,
    public referrerAccountNumber: string,
    public email: string,
  ) {}
}
